import React from 'react';
import './App.css';
import Nav from './components/Nav'
import Header from './components/Header'
import HeaderMgSvc from './components/HeaderMgSvc'
import WhatWhy from './components/WhatWhy'
import HowItWorks from './components/HowItWorks'
import LetsStart from './components/LetsStart'
import Questions from './components/Questions'
import Footer from './components/Footer'
import ContactForm from './components/ContactForm'
import MgSvcSteps from './components/MgSvcSteps'

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {page:'main'};
  }

  pageChanged = (page) => {
    this.setState({page:page}, () => window.scrollTo({top:0,behavior:'instant'}))
  }

  render() {
    const {page} = this.state;
    return (
      <>
        <Nav page={page} pageChanged={this.pageChanged}/>
        <main>
          {page === 'main' && <>
            <Header/>
            <WhatWhy/>
            <HowItWorks/>
            <LetsStart/>
            <Questions/>
          </>}
          {page === 'how' && <>
            <HeaderMgSvc/>
            <MgSvcSteps/>
          </>}
          {page === 'contact' && <ContactForm/>}
        </main>
        <Footer pageChanged={this.pageChanged}/>
      </>
    )
  }
}

export default App;
